export default __webpack_public_path__ + "assets/images/av-new.png";